import { render, staticRenderFns } from "./WebShopPublic.vue?vue&type=template&id=583e5086&"
import script from "./WebShopPublic.vue?vue&type=script&lang=js&"
export * from "./WebShopPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports